<template>
    <div class="footer-top-external phone-class" :style="!notMarginTop ? 'margin-top: 74px' : ''">
        <div class="footer-top-container phone-class">
            <!-- 上部分 -->
            <div class="footer-top">
                <div class="top-middle">
                    <p>集团介绍</p>
                    <p></p>
                    <p>浙江东日股份有限公司</p>
                    <p>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        浙江东日股份有限公司于1997年10月21日在上海证券交易所上市挂牌交易
                        （股票代码：600113)，是温州市第一家国有控股上市公司。
                        公司业务以农产品批发平台运营为主业，覆盖市场建设与开发、
                        市场管理、物流配送、食品生产和金融服务等相关产业。
                    </p>
                    <a class="more" style="margin-top: 5px;" @click="onRouter('/gydr?subNavNumber=1')">查看详情</a>
                </div>
                <div class="top-right">
                    <p>联系我们</p>
                    <p></p>
                    <p>地址：浙江省温州市鹿城区市府路168号合众大厦12楼</p>
                    <p>电话：86-577-88850088</p>
                    <p>传真：86-577-88842287</p>
                    <p>邮编：325003</p>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-background phone-class">
        <div class="footer-container phone-class">
            <!-- 下部分 -->
            <div class="footer phone-class">
                <div class="footer-left phone-class">
                    版权所有&copy;<a @click="onRouter('/')">浙江东日股份有限公司</a>&nbsp;
                    <a href="http://beian.miit.gov.cn" target="_blank">浙ICP备11030285号</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div class="footer-middle phone-class">
                    技术支持：<a href="http://www.horzin.com" target="_blank" title="杭州禾智云信息技术有限公司">杭州禾智云信息技术有限公司</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import router from '@/router';
export default {
    props: {
        notMarginTop : {
            type : Boolean,
            default : false
        },
    },
    data() {
        return {
            
        };
    },
    methods: {
        onRouter(url){
            router.push(url)
            setTimeout(()=>{
                window.location.reload()
            },100)
        },
    },
};
</script>
<style lang="less" scoped>
a{
    cursor: pointer;
}
</style>